module.exports = __webpack_public_path__ + "static/portfolio_gallery_7-cad59dffe5ee2d4654e4070a43098b9f.jpg";